<template>
    <div class="subframe">
        <mt-header :title="title">
            <div slot="left" @click="$router.back()">
                <mt-button icon="back"></mt-button>
            </div>
            <div slot="right">
                <slot name="head"></slot>
            </div>
        </mt-header>
        <div class="subframe-body" wxscrollable>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SubFrame",
        props: ['title']
    }
</script>

<style scoped lang="scss">
    .subframe {
        height: 100vh;
        width: 100vw;
        ::v-deep .mint-header {
            height: 40px;
        }
        .subframe-body {
            overflow: scroll;
            height: calc(100vh - 40px);
            ::v-deep .mint-cell-title {
                min-width: 100px;
            }
        }
        ::v-deep .mint-cell input {
            padding: 5px;
            border-radius: 5px;
            background: #eee;
        }
    }
</style>